const between = (value, min, max) => {
  return min <= value && max >= value;
};
export const isValidCoordinates = (lon, lat) => {
  return longitude(lon) && latitude(lat);
};

const longitude = (lon) => {
  return !!(isNumber(lon) && between(lon, -180, 180));
};

const latitude = (lat) => {
  return !!(isNumber(lat) && between(lat, -90, 90));
};
const isNumber = (n) => {
  return typeof n === "number";
};
